/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chunky_Loved_Gadfly_OfferInputs */

const fr_chunky_loved_gadfly_offer = /** @type {(inputs: Chunky_Loved_Gadfly_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu veux charger ta barre sans te poser de question ?`)
};

/**

* @param {Chunky_Loved_Gadfly_OfferInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const chunky_loved_gadfly_offer = /** @type {((inputs?: Chunky_Loved_Gadfly_OfferInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chunky_Loved_Gadfly_OfferInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_chunky_loved_gadfly_offer(inputs)
});